<template>
  <div class="notification-item">
    <div class="icon">
      <div class="icon-wrapper">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <!--! Font Awesome Free 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc. -->
          <path
            d="M256 32V49.88C328.5 61.39 384 124.2 384 200V233.4C384 278.8 399.5 322.9 427.8 358.4L442.7 377C448.5 384.2 449.6 394.1 445.6 402.4C441.6 410.7 433.2 416 424 416H24C14.77 416 6.365 410.7 2.369 402.4C-1.628 394.1-.504 384.2 5.26 377L20.17 358.4C48.54 322.9 64 278.8 64 233.4V200C64 124.2 119.5 61.39 192 49.88V32C192 14.33 206.3 0 224 0C241.7 0 256 14.33 256 32V32zM216 96C158.6 96 112 142.6 112 200V233.4C112 281.3 98.12 328 72.31 368H375.7C349.9 328 336 281.3 336 233.4V200C336 142.6 289.4 96 232 96H216zM288 448C288 464.1 281.3 481.3 269.3 493.3C257.3 505.3 240.1 512 224 512C207 512 190.7 505.3 178.7 493.3C166.7 481.3 160 464.1 160 448H288z"
          />
        </svg>
      </div>
    </div>
    <div class="content">
      <div class="title">
        {{ notification.title }}
      </div>
      <div class="subtitle">
        {{ notification.subtitle }}
      </div>
      <div class="datetime">
        {{ notification.datetime }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotificationItem",
  props: {
    notification: Object,
  },
};
</script>

<style lang="scss" scoped>
@import url("@/assets/styles/_variables.scss");
.notification-item {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: 10px;
  cursor: pointer;

  & + .notification-item {
    border-top: 1px solid #ddd;
    padding-top: 10px;
  }

  &:hover {
    .icon .icon-wrapper {
      svg {
        fill: #fff;
      }

      &::before {
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
      }
    }
  }

  .icon {
    .icon-wrapper {
      width: 45px;
      height: 45px;
      background-color: $lg_grey;
      border-radius: 100%;
      padding: 12px;
      position: relative;
      overflow: hidden;

      &::before {
        content: "";
        display: block;
        position: absolute;
        right: -45px;
        top: -45px;
        border-radius: 100%;
        width: 10%;
        height: 10%;
        background-color: $primary;
        transition: 0.75s ease-in-out;
      }

      svg {
        width: 100%;
        height: 100%;
        fill: #000;
        position: relative;
        z-index: 1;
        transition: 0.75s ease-in-out;
      }
    }
  }

  .content {
    padding-left: 15px;

    .title {
      font-weight: 600;
      margin: 0 0 3px;
    }

    .subtitle {
      font-size: 0.8rem;
    }

    .datetime {
      font-size: 0.8rem;
      color: $md_grey;
      margin: 8px 0 0;
    }
  }
}
</style>
